<template>
    <div class="currency-select" v-if="selectedCurrency && selectedCurrency.name">
        <form id="currency-form" class="styled-dropdown">
            <div class="btn-group">
                <button data-toggle="dropdown" class="dropdown-toggle">
                    {{ selectedCurrency.symbol }} <span class="hidden-xs">{{ selectedCurrency.name }}</span>
                    <span class="caret"></span>

                    <i class="fa fa-fw fa-chevron-down float-right"></i>
                    <i class="fa fa-fw fa-chevron-up float-right"></i>
                </button>
                <ul class="dropdown-menu">
                    <li
                        class="clearfix"
                        v-for="currency in currencies"
                        :key="currency.name"
                        @click="selectCurrency(currency)"
                        data-dismiss="modal"
                    >
                        <label>{{ currency.symbol }} {{ currency.name }}</label>
                    </li>
                </ul>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import lang from '../../shared/mixins/lang';

import SelectCurrency from 'greenmotion-shared/mixins/selectCurrency';

export default {
    mixins: [lang, SelectCurrency],
    data() {
        return {
            currencyHasChanged: false
        }
    },
    computed: Object.assign(
        {},
        mapGetters({
            currencies: 'getCurrencies',
            selectedCurrency: 'selectedCurrency',
        })
    ),
    mounted() {
        this.$store.dispatch('fetchCurrencies').then(() => {
            // Change the currency in the top header.
            // This is for new users to see the name of the currency matching the one of the converted currency for the quote.
            window.bus.$on('currency.changed', currency => {
                if (! this.currencyHasChanged) {
                    this.currencyHasChanged = true;
                    this.selectCurrency(currency)
                }
            });
        });
    },
};
</script>

<style lang="scss" scoped>
    #currency-form .dropdown-toggle[aria-expanded=true] .fa-chevron-down,
    #currency-form .fa-chevron-up {
        display: none;
    }

    #currency-form .dropdown-toggle[aria-expanded=true] .fa-chevron-up,
    #currency-form .fa-chevron-down {
        display: inline-block;
    }

    @media (min-width: 992px){
        #currency-form .fa-chevron-up,
        #currency-form .fa-chevron-down {
            display: none;
        }

        #currency-form .dropdown-toggle[aria-expanded=true] .fa-chevron-up,
        #currency-form .fa-chevron-down {
            display: none;
        }
    }
</style>
